import { Loading } from 'element-ui';
import { ElLoadingComponent } from 'element-ui/types/loading';

let needLoadingRequestCount: number = 0;
let loading: ElLoadingComponent;

const startLoading = (): void => {
  loading = Loading.service({
    // lock: true,
    text: '加载中……',
    background: 'rgba(0, 0, 0, 0.7)',
  });
};

const endLoading = (): void => {
  loading.close();
};

const tryCloseLoading = (): void => {
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
};

export const showFullScreenLoading = (): void => {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
};

export const tryHideFullScreenLoading = (): void => {
  if (needLoadingRequestCount <= 0) {
    return;
  }
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    setTimeout(tryCloseLoading, 300);
  }
};
